import React from "react";
import { useNavigate } from "react-router-dom";
import { Users, Layers, MessageSquare } from "lucide-react";
import useNotificationStore from "../../store/useNotificationStore";
import UserAuthStore from "../../store/userStore";
import { getTimeAgo } from "../../utils/helpers";
import { markNotificationRead } from "../../api/notifications";

const CATEGORY_ICON = {
  collaboration: Users,
  space: Layers,
  chat: MessageSquare,
};

const CATEGORY_COLOR = {
  collaboration: "text-ink-accent",
  space: "text-ink-violet-400",
  chat: "text-ink-emerald-400",
};

const NotificationItem = ({ notification, onClose }) => {
  const navigate = useNavigate();
  const markRead = useNotificationStore((state) => state.markRead);
  const user = UserAuthStore((state) => state.user);
  const orgId = UserAuthStore((state) => state.orgId);

  const Icon = CATEGORY_ICON[notification.category] ?? MessageSquare;
  const iconColor = CATEGORY_COLOR[notification.category] ?? "text-ink-control-border";

  const handleClick = () => {
    markRead(notification.id);
    if (user?.uid && orgId) {
      markNotificationRead(orgId, user.uid, notification.id).catch(() => {});
    }
    if (notification.navigateTo) {
      navigate(notification.navigateTo);
    }
    onClose?.();
  };

  return (
    <button
      onClick={handleClick}
      className={`w-full flex items-start gap-3 px-4 py-3 text-left transition-colors hover:bg-fill-gray-100 dark:hover:bg-fill-canvas-hover ${
        notification.read ? "opacity-60" : ""
      }`}
    >
      {/* Unread dot */}
      <div className="mt-[5px] shrink-0 w-2 h-2">
        {!notification.read && (
          <div className="w-2 h-2 rounded-full bg-fill-primary" />
        )}
      </div>

      {/* Category icon */}
      <div className="shrink-0 mt-0.5">
        <Icon size={16} className={iconColor} />
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <p className="text-sm text-ink-ink dark:text-ink-white leading-snug truncate-multiline">
          {notification.message}
        </p>
        <p className="text-xs text-ink-control-border mt-0.5">
          {getTimeAgo(notification.timestamp)}
        </p>
      </div>
    </button>
  );
};

export default NotificationItem;
